<template>
  <div
    class="asd20-progress"
    :class="classes"
    :style="`--progress-bg: ${currentSegment.background}`"
  >
    <progress :value="value" :max="max"></progress>
    <div class="asd20-progress__label">
      <span class="asd20-progress__percentage" v-if="showPercentage"
        >{{ Math.round(percentage * 100) }}%&nbsp;</span
      >
      <span>{{ currentSegment.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Asd20Progress',
  props: {
    value: { type: Number, default: 50 },
    max: { type: Number, default: 100 },
    segments: {
      type: Array,
      default: () => [
        {
          label: '',
          threshold: 0.0,
          background: 'hsla(10, 70%, 60%, 1)',
        },
      ],
    },
    reversed: { type: Boolean, default: false },
    condensed: { type: Boolean, default: false },
    showPercentage: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    // shadowLight: {type: Boolean, default: false},
    // shadowDark: {type: Boolean, default: true}
  },

  computed: {
    percentage() {
      return this.value / this.max
    },

    currentSegment() {
      // if (this.percentage >= 1) return this.segments[this.segments.length - 1]
      return this.segments.reduce((final, current) => {
        if (this.percentage >= Number(current.threshold)) {
          return current
        }
        return final
      }, null)
    },

    classes() {
      return {
        'asd20-progress--reversed': this.reversed,
        'asd20-progress--condensed': this.condensed,
        'asd20-progress--flat': this.flat,
        // 'asd20-progress--shadow-light': this.shadowLight,
        // 'asd20-progress--shadow-dark': this.shadowDark
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

:root {
  --progress-bg: var(--color__primary);
}
.asd20-progress {
  display: flex;
  flex-direction: column;

  &__label {
    // font-weight: bold;
    font-size: 0.875rem;
    text-align: right;
    color: var(--color__secondary);
  }

  &--condensed {
    progress {
      height: space(0.25);
    }
    .asd20-progress__label {
      font-size: 0.75rem;
    }
  }
  &--reversed {
    .asd20-progress__label {
      color: var(--color__tertiary);
    }
    &::v-deep progress {
      background-color: var(--color__secondary-t30);
      &::-webkit-progress-bar {
        background-color: var(--color__secondary-t30);
      }
    }
  }
  &--flat {
    &::before {
      border: solid var(--progress-bg) 1px;
      border-radius: space(0.5);
      width: 100%;
      height: 16px;
      position: relative;
      top: 14px;
      right: 6px;
      padding: 0 5px;
      content: '';
    }
    progress {
      &::-webkit-progress-bar {
        background-color: transparent !important;
        height: 10px;
      }
      &::-webkit-progress-value,
      &::-moz-progress-bar {
        background-color: transparent;
      }
    }
    .asd20-progress__label {
      padding-top: space(0.4);
      color: var(--progress-bg);
      font-weight: 800;
    }
  }
  // &--shadow-light{
  //   &::before{
  //     box-shadow: 0 0 70px #fff;
  //   }
  //   .asd20-progress__label{
  //     text-shadow: 0 0 1px #fff;
  //   }
  // }
  // &--shadow-dark{
  //   &::before{
  //     box-shadow: 0 0 70px #000;
  //   }
  //   .asd20-progress__label{
  //     text-shadow: 0 0 1px #000;
  //   }
  // }
  &--condensed {
    progress {
      &::-webkit-progress-bar {
        background-color: transparent;
        height: 6px;
      }
      &::-webkit-progress-value,
      &::-moz-progress-bar {
        height: 6px;
        border-radius: space(0.5);
        // margin: 20px;
      }
    }
    &::before {
      border: solid var(--progress-bg) 1px;
      height: 10px;
      position: relative;
      top: 9px;
      padding: 0 2px;
      right: 3px;
    }
  }
  progress {
    display: block;
    -webkit-appearance: none;
    // background-color: var(--color__tertiary);
    border: none;
    // height: 10px;
    width: 100%;
    margin: 0;
    padding: 0;
    border-radius: space(0.5);
    &::-webkit-progress-bar {
      background-color: var(--color__tertiary);
      border-radius: space(0.5);
    }
    &::-webkit-progress-value {
      background-color: var(--progress-bg);
      border-radius: space(0.5);
    }
    &::-moz-progress-bar {
      background-color: var(--progress-bg);
      border-radius: space(0.5);
    }
  }
}
</style>
